export const environment = {
  URL: 'https://democentral.simadvisory.com',
  KEYCLOAK_URL: 'https://auth.simadvisory.com/auth',
  KEYCLOAK_REALM: 'DEMOCENTRAL',
  KEYCLOAK_CLIENT_ID: 'CLIENT_DEMOCENTRAL',
  PROJECT_ID: 'oh',
  HELP_URL: "https://google.com",
  COMPANY_LOGO_SRC: "assets/image.png",
  SECONDARY_LOGO_SRC: "assets/makeinindia2.png",

  COMPANY_LOGO_TEXT: "SIMA",
  HELP_ENABLED: "true",

  FEEDBACK_URL: "https://docs.google.com/forms/u/0/",
  FEEDBACK_ENABLED: "true",
  NOTIFICATION_ENABLED: "true",
  USER_ENABLED: "true",
  LOGOUT_ENABLED: "true",
  agentApiUrl: 'http://localhost:18080/wrapper/api',
  API_BASE_URL: 'https://democentral.simadvisory.com',
};
